import { render, staticRenderFns } from "./BaseRebateApply.vue?vue&type=template&id=6675b170&scoped=true"
import script from "./BaseRebateApply.vue?vue&type=script&lang=js"
export * from "./BaseRebateApply.vue?vue&type=script&lang=js"
import style0 from "./BaseRebateApply.vue?vue&type=style&index=0&id=6675b170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675b170",
  null
  
)

export default component.exports